import { render, staticRenderFns } from "./ui-rich-color-choicer.vue?vue&type=template&id=d2e78fae&scoped=true&"
import script from "./ui-rich-color-choicer.vue?vue&type=script&lang=js&"
export * from "./ui-rich-color-choicer.vue?vue&type=script&lang=js&"
import style0 from "./ui-rich-color-choicer.vue?vue&type=style&index=0&id=d2e78fae&lang=scss&scoped=true&"
import style1 from "./ui-rich-color-choicer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e78fae",
  null
  
)

export default component.exports